// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2MB7r","insightsList":"newBusinessInsightsMenu_insightsList__1Ppau","active":"newBusinessInsightsMenu_active__2CFDh"};